import type { Dictionary } from './he';

export const en: Dictionary = {
    app_name: 'Crimson Front',
    app_tagline: 'Real-time strategy',

    menu_new_game: 'New game',
    menu_continue: 'Continue',
    menu_settings: 'Settings',
    menu_continue_empty: 'No saved game',
    menu_coming_soon: 'Coming soon',

    lang_switch: 'Switch language',

    build_version_label: 'Build',
    build_reload_hint: 'Tap to reload',

    update_title: 'A new version is available',
    update_action: 'Update now',
    update_dismiss: 'Later',
    offline_ready: 'Ready — the game now works without an internet connection',

    theme_crimson: 'Crimson front',

    map_ridgeline: 'Ridgeline',
    map_duel: 'Duel',
    map_twinbridges: 'Twin Bridges',
    map_bastions: 'Bastions',
    map_crossroads: 'Crossroads',
    map_goldbasin: 'Gold Basin',
    map_fourwinds: 'Four Winds',
    map_pinwheel: 'Pinwheel',
    map_steppes: 'The Steppes',

    difficulty_easy: 'Easy',
    difficulty_normal: 'Normal',
    difficulty_hard: 'Hard',
    menu_difficulty: 'Difficulty',

    unit_gi: 'GI',
    unit_harvester: 'Harvester',
    building_yard: 'Construction yard',
    building_refinery: 'Refinery',
    building_power: 'Power plant',
    building_barracks: 'Barracks',
    building_factory: 'War factory',
    building_pillbox: 'Pillbox',
    building_turret: 'Gun turret',

    building_yard_desc: 'The heart of the base. Without it nothing can be built.',
    building_refinery_desc: 'Harvesters unload ore here and it becomes credits. Your only income.',
    building_power_desc: 'Supplies power. A shortage slows all production and weakens defences.',
    building_barracks_desc: 'Trains infantry. Also unlocks the pillbox.',
    building_factory_desc: 'Builds tanks and harvesters. Also unlocks the gun turret.',
    building_pillbox_desc: 'Cheap defence. Deadly to infantry, barely scratches tanks.',
    building_turret_desc: 'Heavy defence. Stops tanks, wastes shells on infantry.',
    unit_gi_desc: 'Cheap soldier. Good against infantry, weak against armour.',
    unit_grizzly_desc: 'Tank. Strong against armour and structures, slow against spread infantry.',
    unit_harvester_desc: 'Collects ore and hauls it to the refinery. Unarmed — worth protecting.',

    build_needs: 'Needs',
    build_power_use: 'Power draw',
    build_power_gain: 'Power output',
    build_open: 'Build',
    build_tab_buildings: 'Structures',
    build_tab_units: 'Units',
    build_place: 'Place',
    build_cancel: 'Cancel',
    build_rally: 'Where units go',
    build_hint_rally: 'Tap the map — new units will head there',
    build_hint_ready: 'Building ready — open "Build" and tap "Place"',
    build_hint_place: 'Tap a highlighted tile to place it',
    build_hint_bad_spot: 'You cannot build there — only on the highlighted area near your base',
    unit_grizzly: 'Grizzly tank',

    armor_flesh: 'Flesh',
    armor_light: 'Light armour',
    armor_heavy: 'Heavy armour',
    armor_structure: 'Structure',

    game_attack_move: 'Attack-move',
    game_stop: 'Stop',

    result_victory: 'Victory',
    result_defeat: 'Defeat',
    result_back: 'Menu',

    game_select_all: 'Select all',
    game_groups: 'Group',
    game_close: 'Close',
    build_idle: 'Nothing in production',
    build_no_credits: 'Not enough credits — construction stopped',
    build_eta: 'in',
    build_power_hint: 'Consumption out of production. A deficit slows all construction',
    build_explain_hint: 'Info mode — tap an item to read what it does',
    game_repair: 'Repair',
    game_repair_on: 'Repairing',
    game_sell: 'Sell',
    game_sell_yes: 'Sell it?',
    game_sell_confirm: 'Selling refunds half the cost. Tap again',
    armor_air: 'Air',
    unit_gunship: 'Gunship',
    unit_gunship_desc: 'Attacks ground from above and ignores terrain. Immune to most weapons — but falls fast to AA.',
    building_airfield: 'Airfield',
    building_airfield_desc: 'Builds gunships. Opens the air lane — and another production queue.',
    building_aa_gun: 'AA gun',
    building_aa_gun_desc: 'Fires only at aircraft, and is lethal to them. Useless against ground.',
    game_box_select: 'Box select — drag to choose',
    brief_select: 'Press and hold, then drag, to box-select',
    brief_goal: 'Goal: destroy the enemy base',
    brief_economy: 'The harvester mines ore and earns credits',
    brief_power: 'Keep power in surplus — a deficit slows construction',
    result_time: 'Battle time',
    result_built: 'Units built',
    result_lost: 'Units lost',
    result_again: 'Play again',
    game_selected_one: 'One unit selected',
    game_exit_confirm: 'Game saved. Tap again to leave',
    game_exit_yes: 'Leave?',
    game_unit_ready: 'ready',
    game_group_empty: 'Hold to assign the selection to group',
    game_group_cleared: 'Cleared group',
    game_group_hint: 'Tap to recall · hold to assign the selection',
    game_under_attack: 'Base under attack',
    game_deselect: 'Clear',
    game_selected: 'Selected',
    game_units: 'units',
    game_pause: 'Pause',
    game_resume: 'Resume',
    game_hint_select: 'Tap to select · double-tap for all of its type',

    game_back_to_menu: 'Menu',

    menu_multiplayer: 'Multiplayer',
    menu_multiplayer_note: 'Two players, one room code',

    lobby_title: 'Multiplayer',
    lobby_tagline: 'Two players on the same map',
    lobby_map: 'Map',
    lobby_create: 'Create room',
    lobby_create_note: 'You get a code to pass on',
    lobby_join: 'Join',
    lobby_join_label: 'Got a code?',
    lobby_code_label: 'Room code',
    lobby_waiting_hint: 'Give the code to your opponent — the game starts when they join',
    lobby_connecting: 'Connecting…',
    lobby_back: 'Back',
    lobby_retry: 'Try again',
    lobby_error_no_server: 'No game server is configured in this build',
    lobby_error_network: 'Cannot reach the game server',
    lobby_error_not_found: 'No room with that code',
    lobby_error_full: 'That room is already full',
    lobby_error_bad_start: 'Your opponent is on a different version',
    lobby_error_lost: 'The connection dropped',

    net_player_label: 'Player',
    net_leave: 'Leave game',
    net_status_waiting: 'Waiting for opponent…',
    net_status_desync: 'The games diverged — cannot continue',
    net_status_peer_lost: 'Opponent disconnected',
    net_status_ended: 'Game over',

    milestone_notice: 'Combat and terrain. Economy and base building land next.',

    unit_bazooka: 'AT team',
    unit_bazooka_desc:
        'Anti-vehicle rockets. Tears through tanks and harvesters; useless against infantry, buildings and aircraft.',
    unit_hound: 'Scout dog',
    unit_hound_desc:
        'Runs fast and sees far — this is how you learn what the enemy is building. Unarmed, and dies to anything.',
};
